// extracted by css-extract-rspack-plugin
export default {"container":"AYM81","caption":"Q3puU","likeTextRow":"CQVLY","likeIcon":"GGpYh","item_icon_override":"M8c50","itemIconOverride":"M8c50","#":"gLzg3"};